import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';
import FormGroup from '@mui/material/FormGroup';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import InputAdornment from '@mui/material/InputAdornment';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { useState, useEffect } from 'react';
import FormHelpText from './form-helpText';
import { classNames } from '@repo/ui/src/utils/classNames';

const FormSelect = ({ item, unique, submitted }) => {
  const [value, setValue] = useState('');
  const [error, setError] = useState(false);
  const validate = (val) => {
    setValue(val);
    if (item.required && val === '') {
      setError(true);
    } else {
      setError(false);
    }
  };

  useEffect(() => {
    if (submitted) {
      validate(value);
    }
  });

  return (
    <>
      <FormGroup className="tw-py-4">
        <InputLabel className="tw-font-normal tw-text-[#42474a] tra-text-web-body-m">{`${
          item.title
        }${item.required ? ' *' : ''}`}</InputLabel>
        <FormControl fullWidth error={error}>
          <Select
            native
            id={`form-${unique}`}
            name={unique}
            title={unique}
            value={value}
            variant="outlined"
            inputProps={{
              title: `${item.title}${item.required ? ' *' : ''}`,
            }}
            required={item.required}
            onChange={(e) => validate(e.target.value)}
            aria-describedby={`${unique}-help`}
            aria-labelledby={`${unique}-help`}
            icon={{
              position: 'relative',
            }}
            className={classNames(
              'tw-bg-white',
              error ? 'tw-shadow-formError focus:tw-shadow-formError' : 'focus:tw-shadow-form',
            )}
            endAdornment={
              <InputAdornment className="tw-pr-6" position="end">
                {error ? (
                  <CancelIcon color="error" />
                ) : value === '' ? (
                  ''
                ) : (
                  <CheckCircleIcon color="primary" />
                )}
              </InputAdornment>
            }
          >
            <option key="" value="">
              Select One
            </option>
            {item.enumOptions
              ? item.enumOptions.map((option) => (
                  <option
                    key={`option-${unique}-${option.optionTitle
                      .toLowerCase()
                      .replace(/[^\w]/gi, '_')}`}
                    value={option.optionTitle}
                  >
                    {option.optionTitle}
                  </option>
                ))
              : null}
          </Select>
        </FormControl>
        <FormHelperText
          id={`${unique}-help`}
          className={classNames('tw-mt-1 tw-text-red-400', error ? 'tw-block' : 'tw-hidden')}
        >
          {error
            ? item.validationMessage
              ? item.validationMessage
              : `${item.title} is required`
            : ''}
        </FormHelperText>
        <FormHelpText
          display={!!item.helpText}
          unique={unique}
          content={item.helpText !== undefined ? item.helpText : ''}
        />
      </FormGroup>
    </>
  );
};

export default FormSelect;
